import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ClientData} from '../../types/types';

interface ClientDetail {
  clientId: string;
  clientCode: string;
  consilioClientId: string;
  clientName: string;
  createdBy: string;
  createdOn: string;
  budgetConsumptionEnabled?: boolean;
  branches: {
    branchId: number;
    branchName: string;
  }[];
  departments: {
    departmentId: string;
    departmentName: string;
    description: string;
    createdBy: string;
    createdOn: string;
  }[];
  headerSummary: {
    totalDepartments: number;
    totalProjects: number;
    totalPermissionGroups: number;
    totalWorkspaces: number;
    totalBranches: number;
  };
}

interface ClientDetailsState {
  clientList: ClientData[];
  clientDetail: ClientDetail;
  selectedClientId: string;
  triggerProjectsAndSummary: boolean;
}
const initialState: ClientDetailsState = {
  triggerProjectsAndSummary: false,
  clientList: [],
  clientDetail: {
    clientId: '',
    clientCode: '',
    consilioClientId: '',
    clientName: '',
    createdBy: '',
    createdOn: '',
    branches: [
      {
        branchId: 0,
        branchName: '',
      },
    ],
    departments: [
      {
        departmentId: '',
        departmentName: '',
        description: '',
        createdBy: '',
        createdOn: '',
      },
    ],
    headerSummary: {
      totalDepartments: 0,
      totalProjects: 0,
      totalPermissionGroups: 0,
      totalWorkspaces: 0,
      totalBranches: 0,
    },
  },
  selectedClientId: '',
};

const clientListSlice = createSlice({
  name: 'clientList',
  initialState,
  reducers: {
    setClientListData(state, action: PayloadAction<ClientData[]>) {
      state.clientList = action.payload.map(
        (client: ClientData, index: number) => ({
          ...client,
          id: index,
        })
      );
    },
    setClientDetailData(state, action: PayloadAction<ClientDetail>) {
      state.clientDetail = {...action.payload};
    },
    setSelectedClientId(state, action: PayloadAction<string>) {
      state.selectedClientId = action.payload;
    },
    TriggerProjectsAndSummary(state) {
      state.triggerProjectsAndSummary = !state.triggerProjectsAndSummary;
    },
    resetClientList: () => initialState,
  },
});

export const {
  setClientListData,
  setClientDetailData,
  setSelectedClientId,
  TriggerProjectsAndSummary,
  resetClientList,
} = clientListSlice.actions;

export default clientListSlice.reducer;
